export const schemeLists = [
    {
        title: "场馆运营服务管理系统",
        btnText: "场馆运营服务管理",
        imgs: ["scheme1.jpg"],
        id: "scheme-item1",
        descList: [
            {
                icon: "saas.svg",
                text: "云端SaaS系统， 快速部署应用"
            },
            {
                icon: "good.svg",
                text: "线上线下结合，提供最优客户体验"
            },
            {
                icon: "updown.svg",
                text: "针对体育场馆研发的收银终端"
            },
            {
                icon: "gym.svg",
                text: "开放性设计， 支持场馆内对外各项业务对接"
            },
            {
                icon: "for.svg",
                text: "针对综合性体育场馆设计-支持包括游泳馆手牌，篮球馆包场，网球场灯控等各特定的业务管理流程"
            },
        ],
        scene: ["场馆服务人员本地收银、用户远程预订、用户自助下单、财务对账结算、管理者对运营情况跟踪"],
        feature: [
            "云端Saas系统，快速部署应用",
            "线上线下结合，提供最优客户体验",
            "针对体育场馆研发的收银终端",
            "开放性设计，支待场馆内对外各项业务对接",
            "针对综合性体育场馆设计",
        ],
        detailImgs: ["img3.jpg", "img4.jpg"],
        descText: "场馆运营服务管理系统主要解决综合性体育场馆对公众开放收费、预约、会员服务等问题。系统包括云端系统、多种客户端系统（收银机系统、 手持机系统、 自助机系统、 Web 终端、小程序等），还有配套的硬件（收银机、手持机、自助机等）。系统也可以用于单一运动类型场地（如单体羽毛球馆、网球馆、兵乓球馆等）。",
    },
    {
        title: "赛事综合管理系统",
        btnText: "赛事综合管理",
        imgs: ["events.png"],
        id: "scheme-item2",
        descList: [
            {
                icon: "events1.png",
                text: "部署简单，升级方便，可支持多个终端同时使用，方便各个部门人员协作"
            },
            {
                icon: "events2.png",
                text: "具有运动纪录、技术等级纪录导入功能、全能评分参数、分组规则自定义设置功能"
            },
            {
                icon: "events3.png",
                text: "支持多种电子计时仪器的成绩导入"
            },
            {
                icon: "events4.png",
                text: "可生成秩序册、成绩册、成绩公告、分组表、成绩记录表、成绩记录卡等"
            },
            {
                icon: "events5.png",
                text: "多用户多角色的权限管理体系"
            },
        ],
        scene: ["大中型、高规格专业运动会、各类田径运动会及田径运动员的考核"],
        feature: [
            "部署简单，升级方便，可支持多个终端同时使用，方便各个部门人员协作",
            "具有运动纪录、技术等级纪录导入功能、全能评分参数、分组规则自定义设置功能",
            "支持多种电子计时仪器的成绩导入",
            "可生成秩序册、成绩册、成绩公告、分组表、成绩记录表、成绩记录卡等",
            "多用户多角色的权限管理体系",
        ],
        fun: [
            "表单制作：打印输出秩序册、成绩册、成绩公告、分组表、成绩记录表、成绩记录卡等书面表格",
            "运动员检录：根据运动员信息生成检录卡，在现场可由终端实时查阅检录详细信息",
            "权限管理：多用户多角色的权限管理体系，方便管理",
            "实时成绩：支持裁判终端操作录入成绩，支持多种电子计时仪器的成绩导入，提前记录录取规则，实现实时录取",
        ],
        detailImgs: ["img5.jpg", "img6.jpg", "img7.jpg"],
        descText: "赛事综合管理系统可以简化复杂的运动会筹备、组织、管理、协调等工作，解决大中型、高规格专业运动会的各种数据、信息的综合处理的难题，实现网络化、自动化，极大地提离工作效率和信息处理的实时准确性。大量减少运动会工作人员的工作量，降低运动会的开支成本。",
    },
    {
        title: "比赛设备集成管理系统",
        btnText: "比赛设备集成管理",
        imgs: ["equipment.png"],
        id: "scheme-item3",
        descList: [
            {
                icon: "equipment1.svg",
                text: "专业的演出播控能力"
            },
            {
                icon: "equipment2.svg",
                text: "精准的同步控制能力"
            },
            {
                icon: "equipment3.svg",
                text: "可集成度高-拥有数字化接口的系统皆可集成"
            },
            {
                icon: "equipment4.svg",
                text: "易用性高-支持多终端、多用户同时操作"
            }
        ],
        scene: ["场馆设备操作人员或体育展示人员在赛事活动现场集中进行场馆音视频及灯光系统的控制"],
        feature: [
            "场景控制：统一联动控制赛前、赛前热身、赛中、中场休息、退场场景的音视频及场地灯光",
            "内置众多赛事专项系统接口：场地扩声、LED显示屏、场地照明、计时记分等",
            "观众互动信息集成管理,提供赛事观众互动小程序，满足赛事和观众的互动管理",
        ],
        fun: [
            "屏幕显示控制：控制屏幕显示从其他专项系统获取的内容，显示屏幕当前状态",
            "场地照明控制：控制照明场景，显示照明灯光当前状态",
            "场地扩声：控制扩声系统内容输出，和屏幕的同步，返回各回路当前的状态信息",
            "计时记分：获取比赛成绩数据，获取赛场环境数据",
            "标准时钟：获取时钟状态，时钟校准，控制倒计时",
            "升旗控制：发送控制指令，获取国旗当前状态",
            "现场影像采集及回放：获取比赛现场监视画面，回放画面",
            "场景管理：灵活设詈内置场景（赛前、热身、赛中、中场休息、退场等）对各系统的动作关联自定义场景：自定义比赛场景，及场景关联的各系统动作和状态",
        ],
        detailImgs: ["img8.jpg", "img9.jpg", "img10.jpg"],
        descText: "场馆比赛设备集成系统是一套集成式管理系统，系统对体育场馆内屏幕显示、场地照明、场地扩声、计时记分、标准时钟、升旗控制、现场影像采集及回放等各专项系统的集中控制和监视，为场馆运营人员、赛事管理和指挥人员提供一个为比赛服务的集成控制环境。同时，系统能对比赛进行场景管理，实现比赛场景控制。",
    },
    {
        title: "竞赛实时信息发布系统",
        btnText: "竞赛实时信息发布",
        imgs: ["livebg.jpg"],
        id: "scheme-item4",
        descList: [
            {
                icon: "livebg1.svg",
                text: "核心技术基于SDVoE，能够无损无压缩零延时传输4K视频信号"
            },
            {
                icon: "livebg2.svg",
                text: "主要安装在VIP包厢、场馆出入口等，最高可设置多达256个点位"
            },
            {
                icon: "livebg3.svg",
                text: "布线简单：每个点位仅需预埋一根光纤至机房"
            },
            {
                icon: "livebg4.svg",
                text: "真4K画质:无压缩传输4K画面；零延时:实时显示赛事画面"
            }
        ],
        scene: ["大型场馆将比赛信息实时发布到各个终端", "同时显示多路信息，可自主遥控选择所需信号"],
        feature: [
            "支持SDVOE协议",
            "支持4K视频零延时发布",
            "现场无线遥控，自主选择观看信息",
            "提供设备状态监视以及分发信息的实时监视",
        ],
        fun: [
            "终端模式管理:内置模式(四分屏、五分屏、满屏、广告模式)，自定义模式",
            "终端地图:支持导入现场平面图，直观显示设备布点",
            "统一信号源管理:统一管理多路信号源，根据需要选择输出的信号源",
            "易于维护:设备布点图，状态一览，故障实时告警",
        ],
        detailImgs: ["img11.jpg", "img12.jpg", "img13.jpg"],
        descText: "竞赛实时信息发布系统用于在比赛时，把竞赛信息实时、无损的传输到场馆内设詈在各个功能分区的显示设备，并提供灵活的输出控制。"
    },
    {
        title: "计时记分系统",
        btnText: "计时记分",
        imgs: ["time.png", "timebg2.jpg"],
        id: "scheme-item5",
        descList: [
            {
                icon: "time1.svg",
                text: "支持田赛、径赛、游泳、各种球类等30余项比赛"
            },
            {
                icon: "time2.svg",
                text: " 操作简便，适应各种场地环境"
            },
            {
                icon: "time3.svg",
                text: "开放接口，提供实时的数据输出"
            },
            {
                icon: "time4.svg",
                text: "提升比赛管理效率，数字化"
            },
            {
                icon: "time5.svg",
                text: "适应设备体积精巧、功能强大、操作简便、数据安全稳定准确"
            }
        ],
        html: "time.html"
    },
    {
        title: "电视转播及评论布线系统",
        btnText: "电视转播及评论布线",
        imgs: ["television.png"],
        id: "scheme-item6",
        descList: [
            {
                icon: "television1.svg",
                text: "一体化方案，覆盖前端部分(前端摄像机位及接口箱、评论员席位及接口)、机房部分(转播机房、转播线缆交接间)和传输部分"
            },
            {
                icon: "television2.png",
                text: "广电级标准(SMPTE311和SMPTE304)"
            },
            {
                icon: "television4.png",
                text: "电视传播机构可灵活多样的设置转播机位,包括特种摄像机机的使用要求"
            },
            {
                icon: "television4.png",
                text: "满足场馆多功能(赛事、活动、演出)电视转播的使用要求"
            }
        ],
        scene: ["重要赛事、大型政府活动及商业演出时为电视转播提供即插即用的线缆和摄像机接口插座", "为赛事评论席提供音视频信号接入和输出、场馆内部相关系统的音视频系统的链接"],
        feature: [
            "一体化方案，覆盖前端部分（前端摄像机位及接口箱、评论员席位及接口）、机房部分（转播机房、转播线缆交接间）和传输部分",
            "广电级标准{SMPTE3 11和SMPTE304)",
            "电视传播机构可灵活多样的设詈转播机位，包括特种摄像机机的使用要求",
            "满足场馆多功能（赛事、活动、演出）电视转播的使用要求",
        ],
        fun: [
            "可靠性：更好地保证场馆内 重要赛事或重大 活动时的电视转播 质晕",
            "安全性：有效地保护电视转播线缆不受到来自 外部力呈的破坏，特别是设置在观众区域的摄像机位时",
            "便利性：可以在场馆的某些特殊位置设置摄像机位，用以丰富电视转播的画面，提高收视率",
            "经济性：有效地提高线缆的使用效率，可以保证几十年的使用要求，更好地保护资产的投资",
            "及时性：有效地减少电视转播机构转播前后的工作强度；对特殊或临时的转播任务做到快速灵活",
            "连通性：方便把场馆内采集的视频画面，通过场馆内部预先铺设的 线缆和L ED 显示屏连接来显 示现场的画面；可增加竞争力，有利于场馆的市场经营活动",
        ],
        detailImgs: ["img14.jpg"],
        descText: "电视转播和现场评论系统为场馆提供电视直播/转播的所需的基础线缆预埋保证，减少或消除由千临时布线对场馆安全及转播信号安全可能造成的不良影响。"
    },
    {
        title: "场馆指挥调度集成管理系统",
        btnText: "场馆指挥调度",
        imgs: ["control.jpg"],
        id: "scheme-item7",
        descList: [
            {
                icon: "control1.svg",
                text: "多种通信设备统接入:对讲机、单兵终端、 话筒、移动电话、固话、视频监控"
            },
            {
                icon: "control2.svg",
                text: "运维现场事件记录，自动生成运维工单"
            },
            {
                icon: "control3.svg",
                text: "监视大屏的系统信息无缝"
            },
            {
                icon: "control4.svg",
                text: "赛事信息的实时接入和展示"
            },
            {
                icon: "control5.svg",
                text: "无缝对接场馆监控系统的所有摄像头"
            }
        ],
        scene: ["赛事活动时统一通信和指挥调度", "场馆设备日常运维管理和资产管理"],
        feature: [
            "多种通信设备统接入:对讲机、单兵终端、话筒、移动电话、固话、视频监控",
            "运维现场事件记录，自动生成运维工单",
            "监视大屏的系统信息无缝",
            "提供统一指挥调度台指挥调度",
            "赛事信息的实时接入和展示",
        ],
        fun: [
            "语音调度：在系统主界面，直接呼叫某个工作人员或进行群组会议",
            "视频调度：支持多路并发视频通话或让某两个工作人员直接进行视频通话",
            "集群对讲：创建工作人员群组，进行群组会议对讲",
            "地图调度：在地图界面，实现工作人员定位，并通过定位展示，进行对讲或视频",
            "录音：语音调度和应急呼叫发生时，进行录音",
        ],
        detailImgs: ["diaodu1.jpg","diaodu2.jpg","diaodu3.jpg"],
        descText: "场馆运维指挥调度集成管理系统是利用音视频、多媒体和计算机网络等技术，构建的现代场馆内部场馆运维指挥调度集成管理系统是利用音视频、多媒体和计算机网络等技术，构建的现代场馆内部场馆工作人员对智能设备的维护简单高效。"
    },
    {
        title: "标准时钟系统",
        btnText: "标准时钟",
        imgs: ["clock.png"],
        id: "scheme-item8",
        descList: [
            {
                icon: "clock1.svg",
                text: "4G物联网同步，自动连接时钟源,无需复杂网络连线"
            },
            {
                icon: "clock2.svg",
                text: "针对赛事场景设计，倒计时，倒计时带铃等多种场景时钟"
            },
            {
                icon: "clock3.svg",
                text: "安全、方便的远程控制，支持按键触发"
            },
            {
                icon: "clock4.svg",
                text: "无需安装的远程系统，直观看到场馆各时钟状态"
            }
        ],
        scene: ["各比赛专业设备的NTP时间服务源、运动员/教练员休息室时间同步", "中场休息倒计时、游泳馆时钟"],
        feature: [
            "4G物联网同步，自动连接时钟源,无需复杂网络连线",
            "针对赛事场景设计，倒计时，倒计时带铃等多种场景时钟",
            "安全、方便的远程控制，支持按键触发",
            "无需安装的远程系统，直观看到场馆各时钟状态",
        ],
        fun: [
            "同步校对：时钟实时接收云同步时钟信号，可定时对时钟的时间进行校正；时钟具备自守时功能模拟式子钟：采用  \"时：分:\"  二针运行方式数字式子钟：采用\"时:分\"日历式数字钟：可根据需要显示“年、月、日和星期以及农历等信息",
            "标准NTP时间服务",
            "系统监测功能实时监视场馆内各时钟的状态；对全系统时钟进行点对点的控制可以实时控制带倒计时功能的时钟，可以采用标准时间和累计时间倒计时控制；可以提供联动接口，实现系统间的联动控制",
        ],
        detailImgs: ["lock1.jpg","lock2.jpg","lock3.jpg"],
        descText: "标准时钟系统可以为场馆的相关系统的设备和软件提供NTP时间服务。发布在场馆内各功能区和房间的时钟可以保持同步和准确，保证场馆举办的赛事的顺利开展。"
    },
    {
        title: "场馆内通",
        btnText: "场馆内通",
        imgs: ["inside.jpg"],
        id: "scheme-item9",
        detailImgs: ["neitong.jpg","neitong2.jpg","neitong3.jpg","neitong4.jpg"],
        descList: [
            {
                icon: "inside1.svg",
                text: "双工工作方式，通话质量可以达到CD级音频"
            },
            {
                icon: "inside2.svg",
                text: "可以和赛事的电视转播人员的内通系统进行通话连接"
            },
            {
                icon: "inside3.svg",
                text: "在赛事期间为赛事官员管理人员等服务的内部通信指挥调度系统"
            },
            {
                icon: "inside4.svg",
                text: "系统在场地设备机房内设置内通系统通信分站"
            },
        ],
        scene: ["体育展示、赛事保障"],
        feature: [
            "系统为全双工工作方式，通话质量可以达到CD级音频",
            "系统同时预留接口，可接入融媒体通话平台，与网络直播平台也可对接",
        ],
        fun: [
            "针对现代场馆运营配套的专业通讯系统，用于解决复杂工作环境/低延时响应的高质量通讯系统",
            "应用于体育展示，裁判争议判罚（用于视频回放联络），大型赛事、演出配套，现场医疗救护等场合",
            "提高场馆运营效率的必备系统",
        ],
        descText: "系统基于IP技术，采用内通矩阵为核心，建立服务于场馆指挥运行，赛事组织运行，现场表演指挥，体育赛事转播等不同功能分组，通过有线/无线通讯终端完成各组织内部或跨组织的人员联络及沟通。"
    },
    {
        title: "灯光秀/投影秀",
        btnText: "灯光秀、投影秀",
        imgs: ["light.png", "lightbg2.png"],
        id: "scheme-item10",
        descList: [
            {
                icon: "light1.svg",
                text: "前沿的3D投影和灯光呈现技术，将光影与建筑、色彩与线条巧妙结合"
            },
            {
                icon: "light2.svg",
                text: "灯光组合形式更为多样、灯光色彩更为丰富、变化更为强烈"
            },
            {
                icon: "light3.svg",
                text: "可刷新空间的概念，在墙体表面实现空间增强现实"
            },
            {
                icon: "light4.svg",
                text: "应用领域包括：体育场馆、赛事开幕、体育展示、场馆运营等多方面"
            }
        ],
        scene: ["赛事开幕、体育展示"],
        feature: [
            "通过设定的音乐和灯光照射的组合，打破了建筑对传统灯光要求的局限性",
            "将声、光、电、机械、视觉装置等结合，给人们的感官视觉创造更大冲击力",
            "灯光组合形式更为多样、灯光色彩更为丰富、变化更为强烈、用光更为大胆，为观赏者带来视觉震撼感受",
        ],
        detailImgs: ["light1.jpg","light2.jpg","light3.jpg"],
        descText: "场馆投影秀是运用前沿的3D投影和灯光呈现技术，将光影与建筑、色彩与线条巧妙结合，通过影像叠加在建筑物表面呈现千变万化的视觉效果，或将投影投映到地面，让舞台化作一个巨幅的多媒体光影互动表演平台，以投影影像作为载体，将原本平面的舞台用三维艺术呈现出来，让舞台活起来，展现新颖独特的全景化演出。为观众带来强烈的视觉冲击和置身其中的奇幻感觉。它可以刷新空间的概念，在墙体表面实现空间增强现实，颠覆人们固有的空间概念。"
    },
    {
        onlyDetail: true,
        title: "售检票系统",
        id: "scheme-item11",
        scene: ["赛事活动售票、票务设置、票务打印、财务统计、入场验票"],
        feature: [
            "提供及时、准确的客流数据",
            "线上线下结合，多端运行，灵活方便",
            "针对体育场馆研发的售票终端",
            "保证数据准确性，杜绝工作人员营私舞弊",
            "各种赛事活动门票设置灵活",
        ],
        fun: [
            "线上线下多渠道售票：门户网站、小程序、公众号等",
            "票务制作打印：关联场馆信息，根据座位生成电子票，即可打印生成的门票",
            "财务管理：场馆可对门票销售进行精确管理，提高运行效率",
            "现场验票：检票方式多样化， 不同场合可选择不同的检票方式，可使用手持机检票;增加临时检票通道",
            "扫码识别：可支持扫码识别，包括手机二维码、纸质一维码、纸质二维码等多种门票介质",
        ],
        detailImgs: ["shouyanpiao1.jpg","shouyanpiao2.jpg","shouyanpiao3.jpg"],
        descText: "售检票系统是根据目前体育场馆售验票的实际需求而设计研发的，本系统有在线售票和验票功能，对票面设 置、场地区域设置等功 能，主要为各项赛事活动打印销售门票所用。此外，系统 还具备了完善的数据统计与查询功 能，为用户提供了方便的售验票数据的汇总、管理。"
    },
    {
        onlyDetail: true,
        title: "国旗升降系统",
        id: "scheme-item12",
        scene: ["国际赛事颁奖仪式", "大型活动的升旗仪式等"],
        feature: [
            "具有远程自动、本地自动、手动电控、应急手摇4种控制方式，确保在各种场景下完成升旗控制",
            "计算机根据国歌播放时间自动同步兴旗速度,增加升旗仪式的庄重感和可观性",
            "系统具有上限位、下限位、冲顶等多重保护措施，确保系统安全运行",
            "主旗杆按奥运会标准定制,满足各种赛事要求。旗杆材质为304不锈钢，美观大方且适应各种环境",
        ],
        fun: [
            "操作权限管理、个性设置管理、国歌曲库管理、颁奖升旗管理",
            "根据国歌曲目播放时间长度自动计算升旗速度，同时控制播放国歌和启动升旗，确保同步完成",
            "利用触摸屏设置升旗时间以配合乐队演奏时间;故障情况下使用手动电控或手摇装置完成赛事升旗任务",
            "系统数据开放，可以供给比赛中央监控系统或其它第三方软件，以完成多系统联动管理",
        ],
        detailImgs: ["img.jpg", "img1.jpg", "img2.jpg"],
        descText: "国旗自动升降系统(横杆) 应用于体育馆、游泳馆和大型会场等场所，辅助完成国际赛事的颁奖仪式以及重大活动的升旗仪式，是大型国际场馆必备的基础设施。"
    },
    {
        onlyDetail: true,
        title: "光学追踪OTS",
        id: "scheme-item13",
        scene: ["专业足球场球场影像捕捉追踪", "专业足球场球场影像捕捉追踪"],
        fun: [
            "实时把相关各类视频及数据传输给足球教练组及分析团队做赛事评判和分析",
            "可以把相关视频信号、图像图片及数据同步传输给广播公司节目制作",
            "可以把视频和各类数据实时传输到球场大屏，用于体育展示、球迷互动，提高观赛的欣赏愉悦性及观感体验、增加运营方利润收入等",
        ],
        detailImgs: ["ots1.jpg", "ots2.jpg", "ots3.jpg"],
        descText: "该技术是获得FIFA认证的足球运动3D光学追踪系统，基于足球场地实际情况，可以安装6到16个高清摄像头，结合光学图像处理算法软件，可以做到场地内运动物体的实时信息追踪，包括运动员、裁判、和足球等的运动视频，位置信息及运动轨迹等，实时分析运动员跑动距离、速度、加速度、身体耐力、队伍阵型等大数据。"
    },
    {
        onlyDetail: true,
        title: "运动分析",
        id: "scheme-item14",
        scene: ["所有球类比赛分析"],
        feature: [
            "视频录制全自动跟拍，多角度画面、直播画面视角及球队教练视角等",
            "用户可以使用智能平板终端进行远程控制"
        ],
        fun: [
            "基于云端的方式管理设施",
            "视频剪辑分析处理平台",
            "分析回放系统",
        ],
        detailImgs: ["yundongfenxi1.jpg", "yundongfenxi2.jpg"],
        descText: "一站式解决方案：摄像机系统控制、音视频录制、音视频流管理套件可轻松整合至客户端服务器及分析工具"
    },
    {
        onlyDetail: true,
        title: "现场影像采集及回放系统",
        id: "scheme-item15",
        scene: ["运动员、教练员回看训练或赛事视频、裁判员及时获取比赛视频回放画面，用于辅助比赛仲裁", "把系统采集的现场比赛画面或体育展示画面传送给LED显示屏"],
        feature: [
            "采集HD-SDI 视频信号，保证转发的视频满足广电基带信号的要求，回放图像满足高清要求",
            "系统采用广电级的专业摄像机，可以根据赛事或活动的要求，灵活设置视频采集机位",
        ],
        fun: [
            "视频导播切换功能\n通过控制键盘选择摄像机图像切换到指定的视频显示输出通道中\n可以同时监视6路视频西面",
            "高清视频录像功能\n系统可实现高清视频的录像功能，对于录像视频的查询回访可通过网络在任意视频回放工作站上完成",
            "摄像机控制\n系统可实现高清视频的录像功能，对于录像视频的查询回访可通过网络在任意视频回放工作站上完成",
            "摄像机视频信号分发功能\n可以实时把各摄像机的HD-SDI视频基带信号切换到场馆L.ED显示屏等系统中",
        ],
        descText: "现场影像采集及回放系统对场地现场赛事或活动时进行视频摄像并存储，为相关人员提供现场实现场影像采集及回放系统对场地现场赛事或活动时进行视频摄像并存储，为相关人员提供现场实"
    }
];

export const successSchemeLists = [
    {
        img: "img5.jpg",
        title: "FIFA标准足球场-北京工人体育场",
        text: "<p>北京工人体育场，主体建筑总建筑面积38万平方米，场内共有座席6.8万个，为北京市专业足球场、开放型城市体育公园，被评为第一届北京十大建筑之一。2020年7月至2023年3月，北京工人体育场进行了全面的保护性改造复建。</p><p>华亿创新为新工体提供了体育专项智能化设计咨询，以及比赛设备集成系统、场馆实时视频和比赛信息发布系统、售验票系统、计时记分及成绩处理系统、电视转播及现场评论席布线系统、升旗系统、标准时钟系统、现场影像采集回放系统（VR）等专业赛事系统。</p>"
    },
    {
        img: "img6.jpg",
        title: "亚运会专业电竞馆",
        text: "<p>中国杭州电竞中心，又称“星际战舰”，位于浙江省杭州市，以“星际涡旋”为设计理念，是中国国内首座亚运会赛事标准的专业电子竞技场馆，于2020年开工建设，2022年竣工启用，为杭州第19届亚运会电竞比赛场地。中国杭州电竞中心总建筑面积约8万平方米，有约5000个座位。</p><p>我司为杭州电竞中心提供了电竞直转播和现场评论系统、竞赛信息发布系统、升旗控制系统、标准时钟系统、比赛设备及赛事集成管理系统、售验票系统、赛影像采集回放及分析系统、赛事体育展示系统等。</p>"
    },
    {
        img: "img7.jpg",
        title: "大运会主场馆-凤凰山体育公园",
        text: "<p>凤凰山体育公园，位于四川省成都市，由“一场两馆”组成，主要包含一座满足FIFA标准、6万个座位的专业足球场，一座满足NBA标准、1.8万个座位的综合体育馆以及多功能馆，是一座综合性的体育公园，是第31届世界大学生夏季运动会的核心场馆。</p><p>华亿创新为凤凰山体育公园足球场提供了信息发布系统、电视转播系统、标准时钟系统、升旗控制系统、计时记分系统。为体育馆提供了现场影像采集及回放系统、信息发布系统、电视转播系统、标准时钟系统、升旗控制系统。</p>"
    },
    {
        img: "img1.jpg",
        title: "军运会主场馆-武汉五环体育中心",
        text: "<p>武汉五环体育中心是2019年世界军人运动会主要场馆之一，中心承接军运会足球、乒乓球和水上救援三项赛事，分别对应该中心3万座的体育场、8000座体育馆和1000座游泳馆。</p><p>我司为五环体育中心提供了体育专项系统，包括赛事管理系统、标准时钟系统、升旗系统、电视转播系统、赛事信息发布系统、场馆比赛设备集成系统、综合运营管理系统等。</p>"
    },
    {
        img: "img4.jpg",
        title: "全运会主场馆-西安奥体中心",
        text: "<p>西安奥体中心项目地处西安国际港务区，项目总规划面积约6000亩，主要建设内容包括一座可容纳6万人大型体育场。于2021年在陕西举办的第十四届全运会，西安奥体中心为十四运的主赛场及开闭幕式的主会场。</p><p>我司为西安奥体中心设计了体育智能化专项系统，包括:场馆时钟系统、赛事信息发布系统、电视转播系统、升旗系统、场馆运营系统、场馆运维指挥调度集成管理系统等。</p>"
    },
    {
        img: "img3.jpg",
        title: "杭州G20峰会会议中心",
        text: "<p>2016中国杭州G20峰会是指2016年9月4日-5日在中国杭州召开的G20峰会。</p><p>2016中国杭州G20峰会，我司承接了电视转播系统的建设，为峰会的顺利进行，起到积极的作用。</p>"
    },
    {
        img: "img2.jpg",
        title: "冬奥会场馆一首都体育馆",
        text: "<p>首都体育馆修建于1968年，至今已经服役50年。它曾经是北京规模最大、功能最多、适用范围最广的体育馆，北京2022年冬奥会期间，首都体育馆将为冬奥会提供多个场地。</p><p>我司为首都体育馆改造提供了场馆专项系统，包括场馆时钟系统、4K高清赛事信息发布系统、电视转播系统、升旗系统、比赛设备集成系统。</p>"
    },
];

export const productList = [
    {
        id: 1,
        img: "product1.jpg",
        title: "SDVOE超清视频发射/接收控制器",
        title2: "HY-IDF01/TX HY-IDF01/RX",
        desc: "支持输入的高清音视频进行网络化传输，支持SDVOE/x.264模式，供不同场馆的信息发布应用场景需求使用，支持输入的4:4:4全高清视频信号进行传输。",
        performance: [
            "支持输入的高清音视频进行网络化传输，支持SDVOE/x.264模式，供不同场馆的信息发布应用场景需求使用：",
            "全高清无延时模式：支持输入的4:4:4全高清视频信号进行传输，60Hz模式下，延迟在40ms以内。",
            "高清压缩模式：支持进行.264编码压缩，提供性价比高的信息发布方案。"
        ],
        params: [
            "1.具有远程自动、本地自动、手动电控、应急手摇4种控制方式，确保在各种场景下完成升旗控制",
            "2.计算机根据国歌播放时间自动同步兴旗速度,增加升旗仪式的庄重感和可观性",
            "3.系统具有上限位、下限位、冲顶等多重保护措施，确保系统安全运行",
            "4.主旗杆按奥运会标准定制,满足各种赛事要求。旗杆材质为304不锈钢，美观大方且适应各种环境"
        ]
    },
    {
        id: 2,
        img: "product2.jpg",
        title: "HD-SDI高清视频采集编辑处理主机",
        title2: "HY-DVM-MSS ",
        desc: "现场影像采集及回放系统主硬件设备，对场地现场赛事或活动时进行视频摄像并存储，为相关人员提供现场实时视频信号和录像回放信号。"
    },
    {
        id: 3,
        img: "product3.jpg",
        title: "5寸双面数字式子钟（物联网型）",
        title2: "HY-D05DI",
        desc: "是4G物联网时钟方案时钟的一款，超薄设计（双面时钟至35mm），采用5英寸数码管，显示时分；LED显示屏可视视角≥±65º； LED显示屏MTBF≥100,000小时；独立计时精度：≤±0.01秒/天。"
    },
    {
        id: 4,
        img: "product4.jpg",
        title: "升旗系统控制柜",
        title2: "HY-LQ-B",
        desc: "能够精确控制升旗系统的运行，具有本地控制、远程控制切换的功能，提供本地控制及调节升旗时间、急停保护功能等。"
    },
    {
        id: 5,
        img: "product5.jpg",
        title: "比赛设备集成系统软件平台",
        title2: "HY-GC-SPT",
        desc: "是专为体育场馆比赛服务的一套集成式管理平台，系统对体育场馆内屏幕显示及控制系统、场地照明及控制系统、计时记分系统、标准时钟系统等集中控制和监视。"
    },
    {
        id: 6,
        img: "product6.jpg",
        title: "赛事管理系统",
        title2: "HY-GM-PT",
        desc: "本系统解决大中型、高规格专业运动会的各种数据、信息的综合处理，为组委会各职能部门及时地提供准确的数据，极大地提高工作效率和信息处理的实时准确性。"
    },
    {
        id: 7,
        img: "product7.jpg",
        title: "双屏专用售票终端(带售验票软件)",
        title2: "HY-PW-Z02",
        desc: "售检票系统是根据目前体育场馆售验票的实际需求而设计研发的，本系统有在线售票和验票功能，对票面设置、场地区域设置等功能，主要为各项赛事活动打印销售门票所用。"
    },
    {
        id: 8,
        img: "product8.jpg",
        title: "场馆运营管理系统",
        title2: "HY-YY-YG",
        desc: "场馆运营服务管理系统主要解决综合性体育场馆对公众开放收费、预约、会员服务等问题。系统包括云端系统、多种客户端系统(收银机系统、手持机系统、自助机系统等。"
    }
];
